/**
 * Big Win Class
 *
 *
 */

(function () {
  class BigWin extends PIXI.Container {
    constructor() {
      super();

      // Big win levels
      this.NICE_WIN = 1;
      this.BIG_WIN = 2;
      this.SUPER_WIN = 3;
      this.MEGA_WIN = 4;
      this.EPIC_WIN = 5;
      this.AWESOME_WIN = 6;

      this._niceWinThreshold = 10;
      this._bigWinThreshold = 20;
      this._superWinThreshold = 50;
      this._megaWinThreshold = 100;
      this._epicWinThreshold = 200;
      this._awesomeWinThreshold = 500;

      this._totalDuration = 9800;
      this._winType = this.NICE_WIN;

      this.bigWinLevel = [
        {
          bigWinType: "NICEWIN",
          threshold: this._niceWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.1,
        },
        {
          bigWinType: "BIGWIN",
          threshold: this._bigWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.1,
        },
        {
          bigWinType: "SUPERWIN",
          threshold: this._superWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.08,
        },
        {
          bigWinType: "MEGAWIN",
          threshold: this._megaWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.06,
        },
        {
          bigWinType: "EPICWIN",
          threshold: this._epicWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.04,
        },
        {
          bigWinType: "AWESOMEWIN",
          threshold: this._awesomeWinThreshold,
          state: "INITBIGWIN",
          partInt: 0.02,
        },
      ];

      this.bigWinState = "IDLE";

      this.textTween = undefined;
      this.isActive = false;
      this.skipWin = false;
      this.allowSkipWin = false;

      // index into bigWinLevel array
      this.currentLevel = 0;

      this._thresholdMultiplier = 0;

      this.scaleIncrease = 0;

      this.winAmount = 0;

      this.callback = undefined;

      messageBus.subscribe("spinner:WinningLinesEvent", this.doPayWins.bind(this));
      messageBus.subscribe("stake:stakeChanged", this.onStakeChanged.bind(this));

      const self = this;

      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {});

      // these states are for non big wins
      this.stateMachine.addState("LOSSWIN", function () {
        self.updateLossWinState();
      });
      this.stateMachine.addState("LOWWIN", function () {
        self.updateLowWinState();
      });
      this.stateMachine.addState("MIDWIN", function () {
        self.updateMidWinState();
      });
      this.stateMachine.addState("SHOWWINENDING", function () {
        self.updateShowWinText();
      });

      this.stateMachine.addState("INITBIGWIN", function () {
        self.updateInitBigWin();
      });
      this.stateMachine.addState("NICEWIN", function () {
        self.updateNiceWin();
      });
      this.stateMachine.addState("BIGWIN", function () {
        self.updateBigWin();
      });
      this.stateMachine.addState("SUPERWIN", function () {
        self.updateSuperWin();
      });
      this.stateMachine.addState("MEGAWIN", function () {
        self.updateMegaWin();
      });
      this.stateMachine.addState("EPICWIN", function () {
        self.updateEpicWin();
      });
      this.stateMachine.addState("AWESOMEWIN", function () {
        self.updateAwesomeWin();
      });

      this.stateMachine.addState("BOUNCEANDGROW", function () {
        self.updateBounceAndGrow();
      });
      this.stateMachine.addState("ENDSTAGE", function () {
        self.updateEndStage();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    onStakeChanged(stake) {
      this._bigWinCurrentStake = stake;
    }

    getWinType(amount) {
      var stake = gameController.globalHelperGetBaseStake();

      if (amount >= stake * this._awesomeWinThreshold) {
        return this.AWESOME_WIN;
      } else if (amount >= stake * this._epicWinThreshold) {
        return this.EPIC_WIN;
      } else if (amount >= stake * this._megaWinThreshold) {
        return this.MEGA_WIN;
      } else if (amount >= stake * this._superWinThreshold) {
        return this.SUPER_WIN;
      } else if (amount >= stake * this._bigWinThreshold) {
        return this.BIG_WIN;
      } else {
        return this.NICE_WIN;
      }
    }

    getNiceWinThreshold() {
      return this._niceWinThreshold;
    }

    getBigWinThreshold() {
      return this._bigWinThreshold;
    }

    getSuperWinThreshold() {
      return this._superWinThreshold;
    }

    getMegaWinThreshold() {
      return this._megaWinThreshold;
    }

    getEpicWinThreshold() {
      return this._epicWinThreshold;
    }

    getAwesomeWinThreshold() {
      return this._awesomeWinThreshold;
    }

    willTriggerBigWin(amount) {
      const stake = gameController.globalHelperGetBaseStake();
      const threshold = stake * this.getNiceWinThreshold();
      return amount >= threshold;
    }

    async panelPulse(panel, first = false, lastPanelToShow = false, skippedWin = false) {
      this._showingLastPanel = lastPanelToShow;
      const finishedCountUpPromise = new Promise((resolve) => {
        this._finishedCountUpResolve = resolve;
      });

      if (skippedWin) {
        this.skippedWinPanelPulseResolve;
        this.skippedWinPanelPulsePromise = new Promise((res) => {
          this.skippedWinPanelPulseResolve = res;
        });
      }

      let hasPanelPulsePlayed;

      if (first) {
        this._repeatCount = 0;
        this._winAsset.scale.set(0.2);
        this._tweenWinAssetIn = gsap.to(this._winAsset.scale, { delay: 0.25, duration: 0.5, x: 1.1, y: 1.1 });
        this._burstScaleInTween.restart();
      }

      this._tweenPanelAssetIn = gsap
        .timeline()
        .to(panel, { duration: 0.5, y: panel.y - 160 })
        .to(panel.scale, { duration: 0.5, x: 1, y: 1 }, "<");

      if (first) {
        await this._tweenWinAssetIn;
        this._pulseWinAsset = gsap.to(this._winAsset.scale, { duration: 0.2, x: 1, y: 1, repeat: -1, yoyo: true });
        this.allowSkipWin = true;
        if (this.delayedSkipWin) {
          this.delayedSkipWin = false;
          this.skip();
        }
      }

      const playPulseWinAsset = () => {
        if (this._panelPulseAnim) {
          this._panelPulseAnim.kill();
          this._panelPulseAnim = null;
        }
        this._panelPulseAnim = gsap.to(panel.scale, { duration: 0.2, x: 1.1, y: 1.1, repeat: -1, yoyo: true });
      };

      const endPromise = skippedWin ? new Promise((res) => gsap.delayedCall(2, res)) : finishedCountUpPromise;

      endPromise.then(() => {
        this._panelPulseAnim?.pause();

        this._panelPulse = gsap
          .timeline()
          .to(panel.scale, { duration: 0.3, x: 4, y: 4 })
          .to(panel, { duration: 0.2, alpha: 0 }, "<")
          .call(
            () => {
              if (lastPanelToShow) {
                this._pulseWinAsset.pause();
                this._pulseWinAsset = gsap
                  .timeline()
                  .to(this._winAsset.scale, { duration: 0.3, x: 4, y: 4 })
                  .to(this._winAsset, { duration: 0.2, alpha: 0 }, "<")
                  .call(() => {
                    if (skippedWin) {
                      this.skippedWinPanelPulseResolve();
                    }
                  });
              }
            },
            [],
            "<"
          );
      });

      if (first) {
        hasPanelPulsePlayed = true;
        await this._tweenPanelAssetIn;
        playPulseWinAsset();
      } else {
        await this._tweenPanelAssetIn;
        this._pulseWinAsset.eventCallback("onRepeat", async () => {
          this._repeatCount++;
          if (this._winAsset.scale.x > 1.05 && !hasPanelPulsePlayed) {
            hasPanelPulsePlayed = true;
            playPulseWinAsset();
          }
        });
      }
    }

    init() {
      this._winAsset = resourceManager.get("bigWin:winAsset");

      this._bigWinContainer = resourceManager.getContainer("bigWinContainer");
      this._bigWinContainer.visible = false;

      this._congratsText = resourceManager.get("bigWin:bigwinCongrats");
      this._congratsText.visible = false;
      // NOTE: This uses a meter - you can't override the font size of the meter
      this._winAwardTextBack = resourceManager.get("bigWin:awardText");
      this._winAwardTextBack.visible = false;

      this._awardTextBackOffset = 10;

      this._niceWinTextContainer = resourceManager.get("bigWin:niceWinTextContainer");
      this._niceWinTextContainer.visible = false;

      this._bigWinTextContainer = resourceManager.get("bigWin:bigWinTextContainer");
      this._bigWinTextContainer.visible = false;

      this._superWinTextContainer = resourceManager.get("bigWin:superWinTextContainer");
      this._superWinTextContainer.visible = false;

      this._megaWinTextContainer = resourceManager.get("bigWin:megaWinTextContainer");
      this._megaWinTextContainer.visible = false;

      this._epicWinTextContainer = resourceManager.get("bigWin:epicWinTextContainer");
      this._epicWinTextContainer.visible = false;

      this._awesomeWinTextContainer = resourceManager.get("bigWin:awesomeWinTextContainer");
      this._awesomeWinTextContainer.visible = false;

      this._allPanels = [
        this._niceWinTextContainer,
        this._bigWinTextContainer,
        this._superWinTextContainer,
        this._megaWinTextContainer,
        this._epicWinTextContainer,
        this._awesomeWinTextContainer,
      ];

      this._bigwinCongrats = resourceManager.get("bigWin:bigwinCongrats");
      this._bigwinCongrats.visible = false;

      this._bigwinYouWon = resourceManager.get("bigWin:bigwinYouWon");
      this._bigwinYouWon.visible = false;

      this.burst = resourceManager.get("bigWin:Burst");
      this.burst.visible = false;

      // COIN EMITTER
      this._emitterCoins = particleManager.createEmitter(
        "bigwin_coinEmitter",
        "bigWin:particlesContainer",
        0,
        0,
        false
      );
      this._emitterCoins.particleEmitter.emit = false;

      this._emitterTextures = {
        bigWinCoins: [
          PIXI.Texture.from("graphics/Generic/particles/coin01.png"),
          PIXI.Texture.from("graphics/Generic/particles/coin02.png"),
        ],
        superWin: PIXI.Texture.from("graphics/Generic/particles/diamond.png"),
        megaWin: PIXI.Texture.from("graphics/Generic/particles/gemblue.png"),
        epicWin: PIXI.Texture.from("graphics/Generic/particles/gempurple.png"),
        awesomeWin: PIXI.Texture.from("graphics/Generic/particles/gemred.png"),
      };

      this._skipBigWinBox = resourceManager.get("bigWin:skipBigWinBox");

      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.visible = false;
      this._skipBigWinBox.interactive = false;
    }

    isBigWinActive() {
      return this.isActive;
    }

    start(winAmount, callback, capped) {
      this.delayedSkipWin = false;
      gameController.devilCharacter.bigWinAnimation();
      this.startBigWin(winAmount, callback);
    }

    startBigWin(winAmount, callback) {
      this.callback = callback;
      this.winAmount = winAmount;

      this.isActive = true;
      this.skipWin = false;
      this.allowSkipWin = false;

      // find win levels
      this.currentLevel = 0;
      this.scaleIncrease = 0;

      this._winAwardTextBack.alpha = 1.0;

      this._bigWinContainer.visible = true;

      this.burst.visible = true;
      this.burst.alpha = 0;

      gameController.toggleReelDark(true);

      this._burstScaleInTween = gsap
        .timeline({ paused: true })
        .fromTo(
          this.burst.scale,
          { x: 0.5, y: 0.5 },
          {
            duration: 0.5,
            x: 2,
            y: 2,
          }
        )
        .to(this.burst, { alpha: 1, duration: 0.5 }, "<")
        .to(this.burst, {
          duration: 3,
          rotation: Math.PI * 2,
          repeat: -1,
          ease: "none",
        });

      this.burst.rotation = 0;

      this.visible = true;

      this.winAmount = this.winAmount;
      const stake = gameController.globalHelperGetBaseStake();

      this.currentState = undefined;

      // do we do the big free spins anim in free spins mode? find highest level
      for (var i = this.bigWinLevel.length - 1; i >= 0; i--) {
        if (this.winAmount >= this.bigWinLevel[i].threshold * stake) {
          this.targetLevel = this.bigWinLevel[i].bigWinId;

          this.currentState = this.bigWinLevel[i].state;
          break;
        }
      }

      // wait for click - anywhere on screen
      this._skipBigWinBox.visible = true;
      this._skipBigWinBox.alpha = 0;
      this._skipBigWinBox.interactive = true;
      this._skipBigWinBox.mousedown = this._skipBigWinBox.touchstart = this.skip.bind(this);

      this.stateMachine.switchState(this.currentState);

      //soundManager.play('bigWinLoop');

      Reflex.registerEventHandler("orientationChange", this.orientationChange.bind(this));
    }

    doPayWins(winTask) {
      // this.winAmount = winTask.data.totalLineWinnings;
    }

    canSkip() {
      return this.isActive && !this.skipWin && this.allowSkipWin;
    }

    updateLossWinState() {
      // just show the text - outro then slides text to middle and alpha out
      // skip win - fade immediately
      // don't allow skip win for a certain amount of time - button needs to check if we can allow skip win
      if (this.phase.once()) {
        this.allowSkipWin = true;
        if (this.delayedSkipWin) {
          this.delayedSkipWin = false;
          this.skip();
        }

        this._congratsText.visible = true;

        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1.0;
        this._finalScaleY = 1.0;
      }

      if (this.phase.timed(700)) {
        if (this.skipWin) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("SHOWWINENDING");
      }
    }

    updateLowWinState() {
      if (this.phase.once()) {
        this.allowSkipWin = true;
        if (this.delayedSkipWin) {
          this.delayedSkipWin = false;
          this.skip();
        }

        this._congratsText.visible = true;

        this._winAwardTextBack.set(this.winAmount);
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        this._finalScaleX = 1.2;
        this._finalScaleY = 1.2;
      }

      // are we skipping the win
      if (this.skipWin) {
        this.stateMachine.switchState("SHOWWINENDING");
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.0 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      // scale back down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1.5 - 0.3 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.5 - 0.3 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("SHOWWINENDING");
      }

      // end phase
      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 1;
        soundManager.play("bigWinCountUpEnd");
      }
    }

    updateMidWinState() {
      if (this.phase.once()) {
        this.allowSkipWin = true;
        if (this.delayedSkipWin) {
          this.delayedSkipWin = false;
          this.skip();
        }

        this._congratsText.visible = true;

        this._winAwardTextBack.set(0);
        this._winAwardTextBack.scale.x = 5;
        this._winAwardTextBack.scale.y = 5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        const stake = gameController.globalHelperGetBaseStake();

        const maxTime = 3000;
        const minTime = 1000;
        const deltaTime = maxTime - minTime;
        const maxValue = 20 * stake;
        const minValue = 3 * stake;

        const normalisedWin = this.winAmount - minValue;
        const normalisedMax = maxValue - minValue;
        const ratio = normalisedWin / normalisedMax;

        function clamp(val, min, max) {
          return val > max ? max : val < min ? min : val;
        }

        const countUpTime = clamp(ratio * deltaTime + minTime, minTime, maxTime);

        this._winAwardTextBack.countUp(this.winAmount, countUpTime);
      }

      // skip win and force countup to final value
      if (this.skipWin) {
        this.stateMachine.switchState("SHOWWINENDING");
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // scale up and fade in
      if (this.phase.timed(500)) {
        this._winAwardTextBack.scale.x = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 0.5 + 0.7 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1.2;
        this._winAwardTextBack.scale.y = 1.2;
        this._winAwardTextBack.alpha = 1;
      }

      // bounce down
      if (this.phase.timed(142)) {
        this._winAwardTextBack.scale.x = 1.2 - 0.2 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 1.2 - 0.2 * this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
      }

      // bounce back to 1.2x
      if (this.phase.timed(200)) {
        this._winAwardTextBack.scale.x = 1 + this.phase.Progress * 0.2;
        this._winAwardTextBack.scale.y = 1 + this.phase.Progress * 0.2;
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("SHOWWINENDING");
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.scale.x = 1.0;
        this._winAwardTextBack.scale.y = 1.0;
        this._winAwardTextBack.alpha = 1;
      }
    }

    updateShowWinText() {
      this._winAwardTextBack.alpha = 1;
      this._winAwardTextBack.visible = false;

      // we can't skip the final tidy up of the value
      if (this.phase.once()) {
        soundManager.play("bigWinCountUpEnd");
      }

      if (this.phase.timed(750)) {
        // let the player see their win - do nothing
      }

      // now move the text down and fade off
      if (this.phase.timed(300)) {
        this._winAwardTextBack.alpha = 1.0 - this.phase.Progress;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("IDLE");
      }

      if (this.phase.exit()) {
        this._winAwardTextBack.position.setY(endPos);
        this._winAwardTextBack.alpha = 1;
        this._winAwardTextBack.visible = false;

        this.delayedSkipWin = false;

        if (this.callback) {
          this.isActive = false;
          this.callback();
          this.callback = undefined;
        }
      }
    }

    updateInitBigWin() {
      const startScale = 0.2;

      this._winType = this.getWinType(this.winAmount);

      if (this.phase.enter()) {
        // COIN EMITTER
        this._emitterCoins.particleEmitter.particleImages = this._emitterTextures.bigWinCoins;
        this._emitterCoins.particleEmitter._frequency = this.bigWinLevel[0].partInt;
        this._emitterCoins.particleEmitter.emit = true;

        musicManager.playBigWin();

        this._winAsset.alpha = 0;
        this._winAsset.visible = true;
        this._winAsset.scale.x = startScale;
        this._winAsset.scale.y = startScale;

        this._currentPanel = this._niceWinTextContainer;
        this._currentPanel.alpha = 0;
        this._currentPanel.visible = true;
        this._currentPanel.scale.x = startScale;
        this._currentPanel.scale.y = startScale;

        this._winAwardTextBack.scale.x = 0.5;
        this._winAwardTextBack.scale.y = 0.5;
        this._winAwardTextBack.alpha = 0;
        this._winAwardTextBack.visible = true;

        this._winAwardTextBack.set(0);
      }

      if (this.phase.timed(200)) {
        this._winAwardTextBack.scale.x = 0.5 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.scale.y = 0.5 + 0.5 * this.phase.Progress;
        this._winAwardTextBack.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._winAwardTextBack.scale.x = 1;
        this._winAwardTextBack.scale.y = 1;
        this._winAwardTextBack.alpha = 1;
      }

      if (this.phase.once()) {
        this.stateMachine.switchState("NICEWIN");
      }
    }

    async updateNiceWin() {
      if (this.phase.enter()) {
        const threshold = gameController.globalHelperGetBaseStake() * this.getBigWinThreshold();
        const amountToCountUp = Math.min(threshold, this.winAmount);
        this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        soundManager.play("coinLoop");
      }
      if (this.skipWin) {
        this.stateMachine.switchState("BOUNCEANDGROW");
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }
      if (this.phase.once()) {
        this.lastPanelToShow = !(
          this.winAmount >=
          gameController.globalHelperGetBaseStake() * this.getBigWinThreshold()
        );
        this.panelPulse(this._currentPanel, true, this.lastPanelToShow);
      }
      if (this.phase.timed(300)) {
        this._currentPanel.alpha = this.phase.Progress;
        this._winAsset.alpha = this.phase.Progress;
      }
      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }
      if (this.phase.once()) {
        this._panelPulse;
        //this._panelPulse.pause();
        this._finishedCountUpResolve();
        this.stateMachine.switchState("BOUNCEANDGROW");
      }
      if (this.phase.exit()) {
        // which state next
        if (this.winAmount >= gameController.globalHelperGetBaseStake() * this.getBigWinThreshold()) {
          this.currentState = "BIGWIN";
        } else {
          this._thresholdMultiplier = this.getBigWinThreshold();
          this.currentState = "ENDSTAGE";
        }
      }
    }

    async updateBigWin() {
      if (this.phase.enter()) {
        gameController.devilCharacter.biggerWinAnimation();

        this._previousPanel = this._niceWinTextContainer;
        this._currentPanel = this._bigWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.set(0.2);

          const threshold = gameController.globalHelperGetBaseStake() * this.getSuperWinThreshold();
          const previousThreshold = gameController.globalHelperGetBaseStake() * this.getBigWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState("BOUNCEANDGROW");
        this._previousPanel.visible = false;
        this._winAsset.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        this._currentPanel.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this.lastPanelToShow = !(
          this.winAmount >=
          gameController.globalHelperGetBaseStake() * this.getSuperWinThreshold()
        );
        this.panelPulse(this._currentPanel, false, this.lastPanelToShow);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        //this._panelPulse.pause();
        this._finishedCountUpResolve();
        this.stateMachine.switchState("BOUNCEANDGROW");
      }

      if (this.phase.exit()) {
        // which state next
        if (this.winAmount >= gameController.globalHelperGetBaseStake() * this.getSuperWinThreshold()) {
          this.currentState = "SUPERWIN";
        } else {
          this._thresholdMultiplier = this.getBigWinThreshold();
          this.currentState = "ENDSTAGE";
        }
      }
    }

    updateSuperWin() {
      if (this.phase.enter()) {
        this._emitterCoins.particleEmitter.particleImages = [
          ...this._emitterCoins.particleEmitter.particleImages,
          this._emitterTextures.superWin,
        ];
        this._emitterCoins.particleEmitter._frequency = this.bigWinLevel[1].partInt;

        // soundManager.play("bigWinUpgrade");

        this._previousPanel = this._bigWinTextContainer;
        this._currentPanel = this._superWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;
          this._currentPanel.scale.set(0.2);

          const threshold = gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold();
          const previousThreshold = gameController.globalHelperGetBaseStake() * this.getSuperWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState("BOUNCEANDGROW");
        this._previousPanel.visible = false;
        this._winAsset.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        this._currentPanel.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this.lastPanelToShow = !(
          this.winAmount >=
          gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold()
        );
        this.panelPulse(this._currentPanel, false, this.lastPanelToShow);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        //this._panelPulse.pause();
        this._finishedCountUpResolve();
        this.stateMachine.switchState("BOUNCEANDGROW");
      }

      if (this.phase.exit()) {
        // which state next
        if (this.winAmount >= gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold()) {
          this.currentState = "MEGAWIN";
        } else {
          this._thresholdMultiplier = this.getSuperWinThreshold();
          this.currentState = "ENDSTAGE";
        }
      }
    }

    updateMegaWin() {
      if (this.phase.enter()) {
        this._emitterCoins.particleEmitter.particleImages = [
          ...this._emitterCoins.particleEmitter.particleImages,
          this._emitterTextures.megaWin,
        ];
        this._emitterCoins.particleEmitter._frequency = this.bigWinLevel[2].partInt;

        // soundManager.play("bigWinUpgrade");
        this._previousPanel = this._superWinTextContainer;
        this._currentPanel = this._megaWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.scale.set(0.2);
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;

          const threshold = gameController.globalHelperGetBaseStake() * this.getEpicWinThreshold();
          const previousThreshold = gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;

          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState("BOUNCEANDGROW");
        this._previousPanel.visible = false;
        this._winAsset.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        this._currentPanel.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this.lastPanelToShow = !(
          this.winAmount >=
          gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold()
        );
        this.panelPulse(this._currentPanel, false, this.lastPanelToShow);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        //this._panelPulse.pause();
        this._finishedCountUpResolve();
        this.stateMachine.switchState("BOUNCEANDGROW");
      }

      if (this.phase.exit()) {
        // which state next
        if (this.winAmount >= gameController.globalHelperGetBaseStake() * this.getEpicWinThreshold()) {
          this.currentState = "EPICWIN";
        } else {
          this._thresholdMultiplier = this.getMegaWinThreshold();
          this.currentState = "ENDSTAGE";
        }
      }
    }

    updateEpicWin() {
      if (this.phase.enter()) {
        this._emitterCoins.particleEmitter.particleImages = [
          ...this._emitterCoins.particleEmitter.particleImages,
          this._emitterTextures.epicWin,
        ];
        this._emitterCoins.particleEmitter._frequency = this.bigWinLevel[3].partInt;

        // soundManager.play("bigWinUpgrade");
        this._previousPanel = this._megaWinTextContainer;
        this._currentPanel = this._epicWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.scale.set(0.2);
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;

          const threshold = gameController.globalHelperGetBaseStake() * this.getAwesomeWinThreshold();
          const previousThreshold = gameController.globalHelperGetBaseStake() * this.getEpicWinThreshold();

          const amountToCountUp = Math.min(threshold, this.winAmount) - previousThreshold;
          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState("BOUNCEANDGROW");
        this._previousPanel.visible = false;
        this._winAsset.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      // this might not happen until we complete count up
      // swap previous and current panels
      if (this.phase.timed(200)) {
        this._currentPanel.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this.lastPanelToShow = !(
          this.winAmount >=
          gameController.globalHelperGetBaseStake() * this.getMegaWinThreshold()
        );
        this.panelPulse(this._currentPanel, false, this.lastPanelToShow);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        //this._panelPulse.pause();
        this._finishedCountUpResolve();
        this.stateMachine.switchState("BOUNCEANDGROW");
      }

      if (this.phase.exit()) {
        // which state next
        if (this.winAmount >= gameController.globalHelperGetBaseStake() * this.getAwesomeWinThreshold()) {
          this.currentState = "AWESOMEWIN";
        } else {
          this._thresholdMultiplier = this.getEpicWinThreshold();
          this.currentState = "ENDSTAGE";
        }
      }
    }

    updateAwesomeWin() {
      if (this.phase.enter()) {
        this._emitterCoins.particleEmitter.particleImages = [
          ...this._emitterCoins.particleEmitter.particleImages,
          this._emitterTextures.awesomeWin,
        ];
        this._emitterCoins.particleEmitter._frequency = this.bigWinLevel[4].partInt;

        // soundManager.play("bigWinUpgrade");
        this._previousPanel = this._epicWinTextContainer;
        this._currentPanel = this._awesomeWinTextContainer;

        if (!this.skipWin) {
          this._currentPanel.scale.set(0.2);
          this._currentPanel.alpha = 0;
          this._currentPanel.visible = true;

          // do the countup
          const threshold = gameController.globalHelperGetBaseStake() * this.getAwesomeWinThreshold();
          const amountToCountUp = this.winAmount - threshold;

          this._winAwardTextBack.countUp(amountToCountUp, this._totalDuration / this._winType);
        }
      }

      // skip win
      if (this.skipWin) {
        this.stateMachine.switchState("ENDSTAGE");
        this._previousPanel.visible = false;
        this._winAsset.visible = false;
        this._winAwardTextBack.cancelCountUp();
        this._winAwardTextBack.set(this.winAmount);
      }

      if (this.phase.timed(200)) {
        this._currentPanel.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this.panelPulse(this._currentPanel, false, true);
      }

      // wait for count up to complete
      if (this.phase.hold()) {
        if (this._winAwardTextBack.Props.isCounting === false) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this._finishedCountUpResolve();
        this.stateMachine.switchState("ENDSTAGE");
      }

      if (this.phase.exit()) {
        this._thresholdMultiplier = this.getAwesomeWinThreshold();

        if (this._previousPanel !== undefined) {
          // this._currentPanel.scale.set(0.2);
          // this._currentPanel.position.set(660, 340);
          // this._currentPanel.alpha = 0;
          // this._currentPanel.visible = false;
        }
      }
    }

    // Bounce and grow code
    updateBounceAndGrow() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        if (this.currentState === "ENDSTAGE") {
          this.stateMachine.switchState(this.currentState);
          return;
        }
      }

      // if (this.phase.once()) {
      //   this._currentPanel.Props.orgScaleX = this._currentPanel.scale.x;
      //   this._currentPanel.Props.orgScaleY = this._currentPanel.scale.y;
      // }

      if (this.skipWin) {
        this.stateMachine.switchState(this.currentState);
      }

      // // bounce panel
      // if (this.phase.timed(150)) {
      //   let newScale = (Math.sin(Math.PI * this.phase.Progress) * 10) / 100;
      //   this._currentPanel.scale.x = this._currentPanel.Props.orgScaleX + newScale;
      //   this._currentPanel.scale.y = this._currentPanel.Props.orgScaleY + newScale;
      // }

      // if (this.phase.once()) {
      //   this._currentPanel.Props.orgScaleX = this._currentPanel.scale.x;
      //   this._currentPanel.Props.orgScaleY = this._currentPanel.scale.y;
      // }

      // move to the next stage of the big win sequence
      if (this.phase.once()) {
        this.stateMachine.switchState(this.currentState);
      }

      if (this.phase.exit()) {
      }
    }

    _cancelAnimations() {
      if (this._tweenWinAssetIn) {
        this._tweenWinAssetIn.kill();
        this._tweenWinAssetIn = null;
      }
      if (this._pulseWinAsset) {
        this._pulseWinAsset.kill();
        this._pulseWinAsset = null;
      }
      if (this._pulseWinAsset) {
        this._pulseWinAsset.kill();
        this._pulseWinAsset = null;
      }
      if (this._tweenPanelAssetIn) {
        this._tweenPanelAssetIn.kill();
        this._tweenPanelAssetIn = null;
      }
      if (this._panelPulse) {
        this._panelPulse.kill();
        this._panelPulse = null;
      }
      if (this._burstScaleInTween) {
        this._burstScaleInTween.kill();
        this._burstScaleInTween = null;
      }
      if (this._panelPulseAnim) {
        this._panelPulseAnim.kill();
        this._panelPulseAnim = null;
      }
    }

    async updateEndStage() {
      if (this.phase.once()) {
        this.stateMachine.switchState("IDLE");
      }

      if (this.phase.exit()) {
        if (this.skipWin) {
          const isFirstPulse = this._tweenWinAssetIn === null || this._tweenWinAssetIn === undefined;
          if (!this._showingLastPanel || isFirstPulse) {
            this._currentPanel.visible = true;
            this._currentPanel.scale.set(0.2);
            this._currentPanel.alpha = 1;

            this._winAsset.visible = true;
            this._winAsset.alpha = 1;

            this.panelPulse(this._currentPanel, isFirstPulse, true, true);

            await this.skippedWinPanelPulsePromise;
          }
        }

        await this._panelPulse;
        this._cancelAnimations();

        this.showEndScreen();

        // this._winAsset.alpha = 0;
        // this._winAsset.visible = true;
        // this._winAsset.scale.set(0.2);

        this._allPanels.forEach((panel) => {
          panel.scale.set(0.2);
          panel.position.set(660, 340);
          panel.alpha = 0;
          panel.visible = false;
        });
      }
    }

    showEndScreen() {
      musicManager.onBigWinEnd();

      this._bigwinCongrats.visible = true;
      this._bigwinYouWon.visible = true;
      this._bigwinYouWon.alpha = 0;

      this._congratsText.alpha = 0;
      this._congratsText.visible = true;

      this._emitterCoins.particleEmitter.emit = false;

      gsap.to(this.burst, { duration: 1, alpha: 0 });

      const self = this;
      self.outro();
    }

    outro() {
      gameController.devilCharacter.endBigWinAnimation();

      gameController.toggleReelDark(false, 1);

      let self = this;
      timerManager.addTimer(
        1000,
        function (progress) {
          self.alpha = 1 - progress;
        },
        function () {
          self._currentPanel.visible = false;
          self._currentPanel.alpha = 1;
          self._currentPanel.scale.x = 1;
          self._currentPanel.scale.y = 1;

          self.alpha = 1;
          self.visible = false;

          self._bigwinCongrats.visible = false;
          self._bigwinYouWon.visible = false;

          self._congratsText.visible = false;

          self._winAwardTextBack.alpha = 1;
          self._winAwardTextBack.visible = false;

          self.burst.visible = false;

          self._rotate = false;

          Reflex.deregisterEventHandler("orientationChange", self.orientationChange.bind(self));

          self.isActive = false;

          self._skipBigWinBox.alpha = 0;
          self._skipBigWinBox.visible = false;
          self._skipBigWinBox.interactive = false;

          if (self.callback) self.callback();
        }
      );
    }

    orientationChange() {}

    skip() {
      if (this.canSkip()) {
        this.skipWin = true;
      } else {
        this.delayedSkipWin = true;
      }
    }
  }

  var bigWinCreator = function (json) {
    return new BigWin();
  };

  var bigWinInitialiser = function (json, bigWin) {};

  var bigWinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType("BigWin", bigWinCreator, bigWinInitialiser, bigWinFilesRequired);
})();
